import styled, { css } from 'styled-components';

import { CFG_ANIM, CFG_CHROME } from '../../../../../theme/configurator-tokens';

/**
 * Full-bleed loading surface over the device screen cut-out: a single opaque, solid
 * brand-background fill (no gradient — a flat colour repaints instantly, so the
 * surface never flickers when the device is switched), cross-fading out as the
 * iframe fades in.
 */
export const Fill = styled.div<{ $shown: boolean; $bg?: string }>`
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ $bg }) => $bg ?? CFG_CHROME.previewScreen};
  opacity: ${({ $shown }) => ($shown ? 1 : 0)};
  transition: opacity ${CFG_ANIM.PREVIEW_FADE_MS}ms ease;
  pointer-events: none;
`;

/** Animated Whitelabels.com loader (the app boot spinner), 64x64, fading in/out.
 *  The art is white for dark screens; on a light brand fill it's darkened to a black
 *  silhouette ($onLight) so it stays legible. brightness(0) keeps per-bar alpha, so
 *  the loading rhythm survives the recolour.
 *
 *  `$align`: 'center' centres it in the screen cut-out (default — desktop devices, the
 *  fullscreen preview). 'top' pins it into the UPPER band (~a quarter down): the mobile
 *  design-flow phone is deliberately taller than the viewport and its lower half sits
 *  under the bottom sheet / off-screen, so a centred spinner would be masked. */
export const Spinner = styled.img<{ $shown: boolean; $onLight: boolean; $align: 'center' | 'top' }>`
  z-index: 1;
  width: 64px;
  height: 64px;
  display: block;
  object-fit: contain;
  filter: ${({ $onLight }) => ($onLight ? 'brightness(0)' : 'none')};
  opacity: ${({ $shown }) => ($shown ? 1 : 0)};
  transition: opacity ${CFG_ANIM.PREVIEW_FADE_MS}ms ease;
  ${({ $align }) =>
    $align === 'top'
      ? css`
          position: absolute;
          top: 24%;
          left: 50%;
          transform: translate(-50%, -50%);
        `
      : css`
          position: relative;
        `}
`;
